export default __webpack_public_path__ + "static/media/61173.0e41ed30.gif";